import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as navigationActions from '../../navigation/navigation.actions';

import { TextLink } from '../../pages/components';

const Thumb = styled.figure`
  width: 4rem;
  height: 4rem;
  overflow: hidden;
  margin: 0.5rem 1rem;

  img {
    width: 100%;
    height: auto;
  }
`;

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  min-height: 100%;
  cursor: pointer;
`;

class BioNavButton extends Component {
  state = {
    hover: false,
  };

  onMouseOver = () => {
    this.setState({
      hover: true,
    });
  };

  onMouseOut = () => {
    this.setState({
      hover: false,
    });
  };

  onClick = e => {
    const { to, navigate } = this.props;
    e.preventDefault();

    navigate(to);
  };

  render() {
    const {
      isPrev,
      data,
    } = this.props;
    return (
      <StyledContainer
        onClick={this.onClick}
        onMouseEnter={this.onMouseOver}
        onMouseOver={this.onMouseOver}
        onMouseLeave={this.onMouseOut}
        onTouchStart={this.onMouseOver}
        onTouchEnd={this.onMouseOut}
      >
        {!isPrev && (
          <Thumb key="thumb">
            <img src={data.image} alt="" />
          </Thumb>
        )}
        <TextLink isMouseOver={this.state.hover} reverse={isPrev} disableClick>
          {data.firstName}
        </TextLink>
        {isPrev && (
          <Thumb key="thumb">
            <img src={data.image} alt="" />
          </Thumb>
        )}
      </StyledContainer>
    );
  }
}

BioNavButton.propTypes = {
  isPrev: PropTypes.bool,
  data: PropTypes.object.isRequired,
  to: PropTypes.string,
  navigate: PropTypes.func.isRequired,
};

export default connect(null, navigationActions)(BioNavButton);


// WEBPACK FOOTER //
// ./src/modules/people/components/BioNavButton.js